<template>
  <div :class="!($route.query.next_to === 'orderTracking')?'col-12 col-md-6 order-2 order-md-1 p-3 mb-4 card':'col-12 col-md-6 order-2 order-md-1 p-3 mb-4'">
    <form class="form-signin"  v-if="!($route.query.next_to === 'orderTracking')">

      <h1 class="h3 mb-3 font-weight-normal" id="sign-up-banner-head">New Agent Sign Up</h1>
      <ul class="login_features">
        <li id="sign-up-login-feature1">Sell your product efficiently</li>
        <li id="sign-up-login-feature2">Choose plans as you wish</li>
        <li id="sign-up-login-feature3">Track all sell info via email</li>
        <li id="sign-up-login-feature4">Know about the plans via Email </li>
      </ul>
      <router-link
        to="/agentSignUp"
        class="btn btn-lg btn-primary btn-type-primary btn-block btn-outline-secondary"
        type="submit"
        id="vendor-sign-up-account-btn">
        Create New Account</router-link>
    </form>
  </div>
</template>

<script>
export default {
	name: 'agent-signup-banner'
}
</script>

<style scoped>

</style>
